<template>
    <LayoutCookieConsentWrapper
        type="audio"
        disabled-message="Accept cookies to view the play along music."
        class="embed-soundslice"
    >
        <iframe
            :src="`https://www.soundslice.com/${typeForUrl}/${idSoundslice}/embed/?side_video_width=300&amp;narrow_video_height=55p&amp;show_staff=0&amp;show_tab=2&amp;api=1&amp;force_top_video=1`"
            width="100%"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            class="h-[600px] w-full sm:h-[500px] md:h-[600px] lg:h-[780px] vertical-tablet:h-[780px]"
        ></iframe>
    </LayoutCookieConsentWrapper>
</template>

<script>
export default {
    name: 'EmbedSoundslice',
    props: {
        idSoundslice: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        typeForUrl () {
            if (this.type === 'score') return 'scores';
            if (this.type === 'slice') return 'slices';
        }
    }
};

</script>
